import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Preserves bookmarks to the legacy path-segment routes (`/org/:orgId/users`
// etc.) by redirecting them to the new tab-query form
// (`/org/:orgId?tab=users`). Mount one of these per legacy path.
const RedirectToTab = ({ tab }) => {
    const { orgId } = useParams();
    return <Navigate to={`/org/${orgId}?tab=${tab}`} replace />;
};

export default RedirectToTab;
